import yup from './yup'

export const pollFormSchema = ({ associateSpeaker }) =>
  yup.object().shape({
    title: yup.string().required('Poll title is required'),
    speakerId: associateSpeaker
      ? yup.string().required('Please select a speaker to associate with this poll')
      : yup.string().optional(),
    questions: yup.array().of(
      yup.object().shape({
        title: yup.string().required('Question title is required'),
        options: yup
          .array()
          .of(
            yup.object().shape({
              optId: yup.string().required('Option Id is required'),
              opt: yup.string().required('Option is required')
            })
          )
          .min(2, 'At least 2 options are required')
          .max(7, 'Maximum 7 options allowed')
      })
    )
  })
